import axios from '../../axios';
import { toast } from 'react-toastify';
import { ADD_DRIVER, DELETE_DRIVER, GET_DRIVER, UPDATE_DRIVER, GET_ONE_DRIVER } from '../types';

export const getDriver = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/driver/all', { params });

      if (res.data.code === 1) {
         dispatch({
            type: GET_DRIVER,
            payload: {
               data: res.data.data || [],
               pagination: res.data.pagination || {},
               totalCount: res.data.totalCount || 0,
            },
         });
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
      // console.error("Failed to get Driver. Please try again. :", err);
   }
};

export const addDriver = (formData) => async (dispatch) => {
   try {
      const res = await axios.post('/driver/add', formData);

      if (res.data.code === 1) {
         dispatch({ type: ADD_DRIVER, payload: res.data.data });
         setTimeout(() => {
            toast.success('Driver added successfully!');
         }, 1000);
      }
      if (res.data.code === 0) {
         setTimeout(() => {
            toast.error(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
      // toast.error("Failed to add Driver. Please try again. :", err);
   }
};

export const updateDriver = (formData) => async (dispatch) => {
   try {
      const res = await axios.post(`/driver/update`, formData);

      if (res.data.code === 1) {
         dispatch({ type: UPDATE_DRIVER, payload: res.data.data });

         setTimeout(() => {
            toast.success('Driver updated successfully!');
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
      // toast.error("Failed to update Driver. Please try again.");
   }
};

// Delete Driver
export const deleteDriver = (id, companyId) => async (dispatch) => {
   try {
      if (!id) {
         toast.error('Please select any record');
         return false;
      }
      const res = await axios.post(`/driver/delete/${id}/${companyId}`);
      if (res.data.code === 1) {
         dispatch({ type: DELETE_DRIVER, payload: { id } });
         setTimeout(() => {
            toast.success('Driver deleted successfully!');
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
      // toast.error("Failed to delete Driver. Please try again.");
   }
};

export const getSingleDriver = (id) => async (dispatch) => {
   try {
      const res = await axios.get(`/driver/${id}`);
      if (res.data.code === 1) {
         dispatch({ type: GET_ONE_DRIVER, payload: res.data.data });
      }
   } catch (err) {
      console.error('Failed to get item by finish item. Please try again.');
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};
